import {defu} from 'defu'
import SiteUtil from "../utils/siteUtil.js";


export const useApi = async (url, body, options = {}, option = 1, contentType = `application/json`) => {
    const config = useRuntimeConfig()
    const store = useUserStore()
    const router = useRouter()

    const baseURL = config.public.dripApiServer
    if (!baseURL) {
        console.warn('[useApi] dripApiServer is not configured! config.public:', config.public)
    }

    url = SiteUtil.appendDateToUrl(url)
    const defaults = {
        baseURL,
        key: toValue(url),
        headers: store.httpToken ? {
            Authorization: `Bearer ${store?.httpToken?.token}`,
            'Cache-Control': 'no-cache',
        } : {'Cache-Control': 'no-cache',},
        cache: 'no-cache',
        onResponseError({response, request}) {
            if (import.meta.prerender) {
                return
            }

            if (response.status === 401) {
                const isAttendanceEndpoint = request?.includes?.('/attendance/clock-in') ||
                                            request?.includes?.('/attendance/clock-out')

                if (isAttendanceEndpoint) {
                    console.warn('401 Unauthorized on attendance endpoint - Invalid PIN')
                    return
                }

                console.warn('401 Unauthorized - Redirecting to login')
                // Use clearSession (state-only) so we don't trigger the
                // store's own /login navigation and race with ours below.
                if (typeof store.clearSession === 'function') {
                    store.clearSession()
                } else {
                    // Fallback for stores that don't yet expose clearSession
                    // (e.g. pos-ui's user store). logout() handles its own
                    // navigation, so skip the redirectTo append in that case.
                    store.logout()
                    return
                }
                const route = useRoute()
                const candidate = route.fullPath !== '/' && route.fullPath !== '/login' ? route.fullPath : undefined
                const redirectTo = SiteUtil.safeInternalRedirect(candidate)
                navigateTo({
                    path: '/login',
                    query: {
                        ...(redirectTo && {redirectTo}),
                    },
                }, {replace: true})
            }
        }
    }

    if (options?.method?.toUpperCase() === 'POST' || options?.method?.toUpperCase() === 'PUT' || options?.method?.toUpperCase() === 'DELETE' || options?.method?.toUpperCase() === 'PATCH') {
        defaults['body'] = body
    }

    if (option !== 3) {
        defaults['headers']['Content-Type'] = contentType
    }

    // for nice deep defaults, please use unjs/defu
    const params = defu(options, defaults)
    if (option === 1 || option === 3)
        return useFetch(url, params)
    else
        return $fetch(url, params)
}
